const Documents = [
    {
        'project_id': 'Legal',
        'file_name': 'LegalAidBC-Everyday-legal-needs-survey-2020',
        'format': 'PDF',
        'pages': '55',
        'size': '901 KB'
    },
    {
        'project_id': 'Legal',
        'file_name': 'LegalAidBC_service-plan',
        'format': 'PDF',
        'pages': '20',
        'size': '314 KB'
    },
    {
        'project_id': 'Legal',
        'file_name': 'Legal-Officer_job-description',
        'format': 'PDF',
        'pages': '4',
        'size': '94 KB'
    },
    {
        'project_id': 'Legal',
        'file_name': 'a-vision-for-publicly-funded-legal-aid-in-british-columbia',
        'format': 'PDF',
        'pages': '28',
        'size': '186 KB'
    },
    {
        'project_id': 'Accounting',
        'file_name': 'information-bulletin_retail-sales-tax-act',
        'format': 'PDF',
        'pages': '11',
        'size': '160 KB'
    },
    {
        'project_id': 'Accounting',
        'file_name': 'CertifiedGeneralAccountant-NewBrunswick',
        'format': 'PDF',
        'pages': '3',
        'size': '236 KB'
    },
    {
        'project_id': 'Accounting',
        'file_name': 'Acceptible-Accounting-Principles-and-Auditing-Standards',
        'format': 'PDF',
        'pages': '44',
        'size': '97 KB'
    },
    {
        'project_id': 'Accounting',
        'file_name': 'audit-accounting-estimates-StrengtheningAuditQuality',
        'format': 'PDF',
        'pages': '7',
        'size': '765 KB'
    },
    {
        'project_id': 'Construction',
        'file_name': 'BRITISH-COLUMBIA_construction-maintenance-looking-forward-2019',
        'format': 'PDF',
        'pages': '16',
        'size': '2 MB'
    },
    {
        'project_id': 'Construction',
        'file_name': 'glossary-of-construction-terms',
        'format': 'PDF',
        'pages': '8',
        'size': '140 KB'
    },
    {
        'project_id': 'Construction',
        'file_name': 'BRITISH-COLUMBIA_construction-maintenance-looking-forward-2021',
        'format': 'PDF',
        'pages': '24',
        'size': '3 MB'
    },
    {
        'project_id': 'Construction',
        'file_name': 'bc-construction-standards-and-guidelines-2019',
        'format': 'PDF',
        'pages': '10',
        'size': '391 KB'
    },
    {
        'project_id': 'Construction',
        'file_name': 'construction-details-for-oil-and-gas-activities',
        'format': 'PDF',
        'pages': '8',
        'size': '327 KB'
    },
   {
        'project_id': 'Insurance',
        'file_name': 'code-of-conduct-for-authorized-insurance-activities',
        'format': 'PDF',
        'pages': '4',
        'size': '157 KB'
   },
   {
       'project_id': 'Insurance',
       'file_name': 'vehicle-insurance-trainers-module',
       'format': 'PDF',
       'pages': '16',
       'size': '476 KB'
   },
   {
       'project_id': 'Insurance',
       'file_name': 'PrinciplesForTheSaleOfInsurance',
       'format': 'PDF',
       'pages': '1',
       'size': '163 KB'
   },
     {
       'project_id': 'Insurance',
       'file_name': 'BCHouseing-regulatory-bulletin',
       'format': 'PDF',
       'pages': '2',
       'size': '618 KB'
   },
   {
       'project_id': 'Retail',
       'file_name': 'how_to_determin_a_right_retail_price_for_your_product',
       'format': 'PDF',
       'pages': '4',
       'size': '1 MB'
   },
    {
       'project_id': 'Retail',
       'file_name': 'Examining-the-impacts-of-covid19-on-retail-industry',
       'format': 'PDF',
       'pages': '12',
       'size': '514 KB'
   },
    {
       'project_id': 'Retail',
       'file_name': 'Retail-General-Policy',
       'format': 'PDF',
       'pages': '17',
       'size': '455 KB'
   },
  
]

export default Documents